import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { SessionStorageManager } from '@atlas/core';

import { REDIRECT_DATA_AFTER_DEPOSIT } from 'src/common/constants';

const useRedirectAfterDeposit = () => {
  const { push: historyPush } = useHistory();

  useEffect(() => {
    const redirectData = SessionStorageManager.getItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (!redirectData) return;

    const { expirationTime, url } = JSON.parse(redirectData);

    SessionStorageManager.removeItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (Date.now() < expirationTime && url) {
      historyPush(url);
    }
  }, [historyPush]);
};

export default useRedirectAfterDeposit;